import React, {
  useCallback, useContext, useEffect, useState,
} from 'react';
import { useHistory } from 'react-router-dom';
// eslint-disable-next-line no-restricted-imports
import PropTypes from 'prop-types';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { VRM as THCVRM } from '@motorway/mw-highway-code/alpha';

import { VehicleLookupContext } from 'Context/vehicleLookup';

import { HERO_ANIMATION_STATES } from 'Utilities/animation';
import { VRM_CHECK_CODES } from 'Utilities/vrm';

import { CONTENT_SIZES } from 'Layout';

import { LogoAffiliate } from 'Storybook/components/local/LogoAffiliate/LogoAffiliate';

import VrmErrors from '../../../contentPages/ulezPage/VrmErrors/VrmErrors';
import VrmInput from '../../../fastlane/vrmInput/VrmInput';
import LocalTexts from '../AffiliatePageTexts.json';

import styles from './VRM.scss';

const LocalT = new MDText(LocalTexts);

const VRM = ({ affiliate = '' }) => {
  const history = useHistory();
  const { vehicleLookupState: vehicle } = useContext(VehicleLookupContext);
  const [showMileage, setShowMileage] = useState(false);
  const [loading, setLoading] = useState(HERO_ANIMATION_STATES.none);
  const isTransition = loading === HERO_ANIMATION_STATES.mileage;
  const loadingHandler = useCallback((val) => setLoading(val), []);
  const hasError = vehicle?.resultError;

  useEffect(() => {
    if (isTransition) {
      history.push(`/${vehicle.vrm}`);
    }
  }, [isTransition]);

  return (
    <aside className={cx(styles.vrmBox, { [styles.error]: false })}>
      {
        hasError ? (
          <VrmErrors error={hasError?.msg} />
        ) : (
          <>
            {(affiliate && !showMileage) && (
              <div className={cx(styles.partnership, { [styles[affiliate]]: styles?.[affiliate] })}>
                {LocalT.translate('vrm.partnership')}
                <LogoAffiliate affiliate={affiliate} className={styles.logo} />
              </div>
            )}
            {
              showMileage ? (
                <div className={styles.vehicle}>
                  <THCVRM text={vehicle?.vrm_pretty} />
                  <h2>
                    {vehicle?.make?.display_name}
                    {' '}
                    {vehicle?.model}
                  </h2>
                </div>
              ) : (
                <>
                  <h3 className={styles.label}>
                    {LocalT.translate('vrm.title')}
                  </h3>
                  <p className={styles.subDesc}>
                    {LocalT.translate('heroStrap')}
                  </p>
                </>
              )
            }
          </>
        )
      }
      {![
        VRM_CHECK_CODES.BAD_REQUEST,
        VRM_CHECK_CODES.EXCEEDED,
        VRM_CHECK_CODES.TOO_MANY_REQUESTS,
        VRM_CHECK_CODES.VEHICLE_GENERATION_FAILURE,
      ].includes(hasError?.msg) && (
        <VrmInput
          maxWidth={CONTENT_SIZES.full}
          {...{
            loadingHandler,
            setShowMileage,
            showMileage,
            vehicle,
          }}
        />
      )}
    </aside>
  );
};

VRM.propTypes = {
  affiliate: PropTypes.string,
};

export default VRM;
